function collidesWith(a, b) {
  return a.end > b.start && a.start < b.end;
}

function checkCollision(eventArr) {
  for (var i = 0; i < eventArr.length; i++) {
    eventArr[i].cols = [];
    eventArr[i].colsBefore = [];
    for (var j = 0; j < eventArr.length; j++) {
      if (collidesWith(eventArr[i], eventArr[j])) {
        eventArr[i].cols.push(j);
        if (i > j) eventArr[i].colsBefore.push(j); //also list which of the conflicts came before
      }
    }
  }
  return eventArr;
}

export function updateEvents(eventArr, { listPadding, defaultLeft }) {
  eventArr = checkCollision(eventArr);
  let maxLeft = 0;
  const arr = eventArr.slice(0); //clone the array
  for (let i = 0; i < arr.length; i++) {
    const el = arr[i];

    if (i > 0 && el.colsBefore.length > 0) {
      //check column if not the first event and the event has collisions with prior events
      if (arr[i - 1].column > 0) {
        //if previous event wasn't in the first column, there may be space to the left of it
        for (let j = 0; j < arr[i - 1].column; j++) {
          //look through all the columns to the left of the previous event
          if (el.colsBefore.indexOf(i - (j + 2)) === -1) {
            //the current event doesn't collide with the event being checked...
            el.column = arr[i - (j + 2)].column; //...and can be put in the same column as it
          }
        }
        if (typeof el.column === 'undefined') el.column = arr[i - 1].column + 1; //if there wasn't any free space, but it ito the right of the previous event
      } else {
        let column = 0;
        for (let j = 0; j < el.colsBefore.length; j++) {
          //go through each column to see where's space...
          if (arr[el.colsBefore[el.colsBefore.length - 1 - j]].column == column) column++;
        }
        el.column = column;
      }
    } else el.column = 0;
  }
  //We need the column for every event before we can determine the appropriate width and left-position, so this is in a different for-loop:
  for (let i = 0; i < arr.length; i++) {
    arr[i].totalColumns = 0;
    if (arr[i].cols.length > 1) {
      //if event collides
      const conflictGroup = []; //store here each column in the current event group
      const conflictingColumns = []; //and here the column of each of the events in the group
      addConflictsToGroup(arr[i]);
      function addConflictsToGroup(a) {
        for (let k = 0; k < a.cols.length; k++) {
          if (conflictGroup.indexOf(a.cols[k]) === -1) {
            //don't add same event twice to avoid infinite loop
            conflictGroup.push(a.cols[k]);
            conflictingColumns.push(arr[a.cols[k]].column);
            addConflictsToGroup(arr[a.cols[k]]); //check also the events this event conflicts with
          }
        }
      }
      arr[i].totalColumns = Math.max.apply(null, conflictingColumns); //set the greatest value as number of columns
    }

    arr[i].left =
      arr[i].column === 0
        ? defaultLeft + 'px'
        : `calc(((100% / ${arr[i].totalColumns + 1}) * ${arr[i].column}) - ${listPadding}px)`;
    maxLeft = (arr[i].totalColumns + 1) * 200; // 200 is min-width
  }
  return [arr, maxLeft];
}
